import {DenialLetterParams} from 'domain/usecases';
import {makeGetDenialLetter} from 'main/factories/usecases/private/authorizations';

export const getDenialLetter = async (params: DenialLetterParams) => {
	const denialLetterBlob = await makeGetDenialLetter().get(params);

	if (!(denialLetterBlob instanceof Blob)) {
		throw new Error('O retorno não é um Blob válido.');
	}

	return denialLetterBlob;
};
